import Logger from './logger';
import Controller from './controller';

const cache = {};

function service(connection, opts = {}) {
    const { debug = false, forceNew = false } = opts;

    Logger.debug = debug;

    const { url, params = {} } = connection;
    const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const query = new URLSearchParams(params).toString();
    const uri = (url.startsWith('//') ? `${scheme}:` : '') + `${url}/ws/?${query}`;
    let ctrl = null;

    if (forceNew) {
        Logger.info('ignoring cache');
        ctrl = new Controller(uri, opts);
    } else {
        if (!cache[uri]) {
            Logger.info('new instance');
            cache[uri] = new Controller(uri, opts);
        }
        ctrl = cache[uri];
    }

    return ctrl.socket('ws', opts);
}

export { service as default };
